// import {  ref } from 'vue'
// import { get } from '../../../utils/index'
import moment from 'moment'
import { get } from '../../../utils/index'

import { pgMessage } from '../../message/index'
/**
 * 通过excel添加商品 业务处理逻辑（都是业务逻辑，不允许改组件自有功能）
 */
export async function useExcelAdd(props, excelData) {
  // 优先判断一些需要退出的条件 不满足要求的 不用处理其他信息
  // 税率-> attrs.valueDouble.saleReturnCostRate / rate字段 是否值在要求的税率内
  const costRate = excelData.data['attrs.valueDouble.saleReturnCostRate'] ?? [] // 成本税率
  const rate = excelData.data['rate'] ?? [] // 普通税率

  if (costRate.length > 0 || rate.length > 0) {
    let systemRate = [] // 系统税率

    const [res] = await get(props.rateUrl)
    systemRate = res.data.map((im) => im.code)

    let illegalityRete = []
    for (const element of costRate) {
      if (!systemRate.includes(element)) illegalityRete.push(element)
    }

    if (illegalityRete.length > 0) {
      pgMessage.warning(`提交失败，存在不符合要求的成本税率：${illegalityRete.join(',')}`)
      return false
    }

    for (const element of rate) {
      if (!systemRate.includes(element)) illegalityRete.push(element)
    }

    if (illegalityRete.length > 0) {
      pgMessage.warning(`提交失败，存在不符合要求的税率：${illegalityRete.join(',')}`)
      return false
    }
  }

  // 接下来处理需要格式化的数据
  for (const key of Object.keys(excelData.data)) {
    excelData.data[key] = excelData.data[key].map((element) => {
      // 价格->处理 pricing，price 数据，处理 价格可能出现的非 正常数据，比如：0425,525,552,.456 会删除第一位0 和中间的逗号

      if (~['pricing', 'price'].indexOf(key)) {
        element = element.replace(/[^0-9|\.]/g, '').replace(/^0+/, '')
      }

      // 日期-> 把日期都改成 YYYY-MM-DD的形式，在excel中 日期可能是 2023/11/6 这种形式
      if (
        ~[
          'goodsKeeping.periodBegin',
          'goodsKeeping.periodEnd',
          'goodsKeeping.sterilizeBegin',
          'goodsKeeping.sterilizeEnd',
          'goodsKeeping.sterilizeExpire',
        ].indexOf(key)
      ) {
        element = moment(element).format('YYYY-MM-DD')
      }
      return element
    })
  }

  //调整字段顺序 解决反算问题 由于反算时按照勾选的顺序进行反算，
  // 导致采购含税单价和采购无税单价出现问题
  // 所以如果勾选了采购税率(attrs.valueDouble.saleReturnCostRate)、采购无税单价(cost)、采购含税单价(netCost)时将采购税率挪到前面
  // 这里把他们都放到最后去

  const saleReturnCostRateIndex = excelData.type.findIndex(
    (ele) => ele === 'attrs.valueDouble.saleReturnCostRate'
  )
  const netCostIndex = excelData.type.findIndex((ele) => ele === 'netCost')
  const costIndex = excelData.type.findIndex((ele) => ele === 'cost')
  if (saleReturnCostRateIndex !== -1) {
    excelData.type.splice(saleReturnCostRateIndex, 1)
    excelData.type.splice(netCostIndex, 0, 'attrs.valueDouble.saleReturnCostRate')
  }
  if (netCostIndex !== -1) {
    excelData.type.splice(netCostIndex, 1)
    excelData.type.splice(netCostIndex, 0, 'netCost')
  }
  if (costIndex !== -1) {
    excelData.type.splice(costIndex, 1)
    excelData.type.splice(costIndex, 0, 'cost')
  }

  // 是否 需要处理code相关字段，如果有code，需要处理替换或者插入的操作 number 不是手动
  // if (
  //   !excelData.data.code &&
  //   !excelData.data.number &&
  //   props.options.some((im) => 'number' === im.code && !im.notHand) &&
  //   !excelData.data.insurance &&
  //   !excelData.data.batchNumbers &&
  //   !excelData.data.saleReturnSupplier &&
  //   !excelData.data.saleReturnAgreement
  // ) {
  //   excelData.hasConvert = true
  // }

  // //如果 hasConvert = true 为数据单独塞一个 master: true
  // if (excelData.hasConvert) {
  //   excelData['excelData'] = []
  //   // 依照旧药械闪加的逻辑，如果没有code那些，需要增加
  //   for (let index = 0; index < excelData.data[excelData.type[0]].length; index++) {
  //     excelData['excelData'].push({ master: true })
  //   }
  // }
}
